/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { Select, Box, Avatar } from "@mui/material";
import React from "react";
import usFlag from "../../assets/images/usa_flag.svg";
import esFlag from "../../assets/images/spain_flag.svg";
import { useTranslation } from "react-i18next";
import { StyledMenuItem } from "../styled_menu_item";

const flagMap = {
  en: usFlag,
  es: esFlag,
};

const languageToLabel = {
  en: "English",
  es: "Español",
};

export default function LanguageSelector({ value, onChange, sx }) {
  const { i18n } = useTranslation();

  const handleChange = (event) => {
    const newLang = event.target.value;
    i18n.changeLanguage(newLang);
    onChange(newLang);
  };

  return (
    <Select
      value={value}
      onChange={handleChange}
      variant="outlined"
      size="small"
      sx={sx}
    >
      {Object.entries(flagMap).map(([lang, flag]) => (
        <StyledMenuItem value={lang} key={lang}>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Avatar
              src={flag}
              alt={lang}
              sx={{ width: 24, height: 24, mr: 1 }}
            />
            {languageToLabel[lang]}
          </Box>
        </StyledMenuItem>
      ))}
    </Select>
  );
}
